<!-- Start FunFacts Area -->
<section class="funfacts-area ptb-110">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-12 col-sm-12">
                <div class="single-funfacts">
                    
                    <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle"
                          stroke-dasharray="60, 100"
                          d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        
                      <text x="18" y="20.35" class="percentage">60%</text>
                      </svg>
                    <span>Design</span>
                    <h3>Codes</h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-12 col-sm-12">
                <div class="single-funfacts">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle"
                          stroke-dasharray="75, 100"
                          d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        
                      <text x="18" y="20.35" class="percentage">75%</text>
                      </svg>
                    <span>Our happy</span>
                    <h3>Clients</h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-12 col-sm-12">
                <div class="single-funfacts">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle"
                          stroke-dasharray="85, 100"
                          d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        
                      <text x="18" y="20.35" class="percentage">85%</text>
                      </svg>
                    <span>Projects</span>
                    <h3>Design</h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-12 col-sm-12">
                <div class="single-funfacts">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle"
                          stroke-dasharray="95, 100"
                          d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        
                      <text x="18" y="20.35" class="percentage">95%</text>
                      </svg>
                    <span>Completed</span>
                    <h3>Projects</h3>
                </div>
            </div>
        </div>
    </div>

    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</section>
<!-- End FunFacts Area -->
